<template>
<div>
  <b-card no-body class="mb-0">

    <div class="m-2">

      <!-- Table Top -->
      <b-row class="mb-2">

        <!-- Per Page -->
        <b-col cols="12" md="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>{{ $t('Show')}}</label>
          <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
          <label>{{ $t('entries')}}</label>
        </b-col>

        <!-- Filtro: Customer (Autosuggest) -->
        <b-col cols="12" md="3" class="mb-1 mb-md-0">
          <div class="position-relative w-100 align-items-center d-flex">
            <vue-autosuggest
                v-model="filterSearchCustomer"
                :suggestions="filterFilteredOptions"
                :input-props="{ 
                  id: 'filter-autosuggest__input', 
                  class: 'form-control w-100', 
                  placeholder: $t('Filter by Customer (min. 3 characters)...') 
                }"
                @selected="onFilterCustomerSelected"
                @input="onFilterCustomerInputChange"
                class="w-100"
            >
              <template slot-scope="{suggestion}">
                <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
              </template>
            </vue-autosuggest>

            <feather-icon
                v-if="filterSearchCustomer"
                icon="XIcon"
                class="cursor-pointer position-absolute text-muted"
                style="right: 12px; z-index: 10;"
                @click="clearCustomerFilter"
            />
          </div>
        </b-col>

        <!-- Filtro: Fabricante -->
        <b-col cols="12" md="3" class="mb-1 mb-md-0">
          <v-select
              v-model="integration"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="vendorFilterOptions"
              :reduce="opt => opt.value"
              :clearable="false"
              :placeholder="$t('Filter by manufacturer')"
              input-id="filter-vendor-select"
              class="w-100"
          />
        </b-col>

        <!-- Search Geral & Botão Adicionar -->
        <b-col cols="12" md="4">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('General search')" />
            <b-button
                variant="primary"
                @click="openAddIntegrationModal"
            >
              <span class="text-nowrap d-flex align-items-center">
                <feather-icon icon="PlusIcon" class="mr-50" />
                {{ $t('Add') }}
              </span>
            </b-button>
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table ref="refIntegrationListTable" class="position-relative" :items="fetchIntegrations" responsive :fields="tableColumns" primary-key="rowId" show-empty :empty-text="$t('No matching record found')" >

      <!-- Column: Customer name -->
      <template #head(customerName)>
        {{ $t('Customer')}}
      </template>
      <template #cell(customerName)="data">
        <div class="font-weight-bold d-block text-nowrap">
          {{ data.item.customerName }}
        </div>
      </template>

      <!-- Column:  integrationName -->
      <template #head(integrationName)>
        {{ $t('Integration')}}
      </template>
      <template #cell(integrationName)="data">
        <div class="font-weight-bold d-block text-nowrap">
          {{ vendorLabel(data.item.integrationName) }}
        </div>
      </template>

          <!-- Column: expiresAtUtc-->
      <template #head(expiresAtUtc)>
        {{ $t('Expiration Date (UTC)')}}
      </template>
      <template #cell(expiresAtUtc)="data">
        <div class="font-weight-bold d-block text-nowrap">
          {{ formatDate(data.item.expiresAtUtc) }}
        </div>
      </template>


      <!-- Column: Actions -->
      <template #head(actions)>
        <div class="text-center">{{ $t('Actions')}}</div>
      </template>
      <template #cell(actions)="data">
        <div class="text-center">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <!-- Ícone de Menu (Sanduíche/Kebab) -->
            <template #button-content>
              <feather-icon icon="MenuIcon" size="18" class="align-middle text-body" />
            </template>

            <!-- Opção 1: Visualizar Ativos -->
            <b-dropdown-item @click="openAssetSummaryModal(data.item)">
              <feather-icon icon="TruckIcon" class="mr-50" />
              <span class="align-middle">{{ $t('Last Telemetry') }}</span>
            </b-dropdown-item>

            <b-dropdown-item @click="forceTelemetry(data.item)">
              <feather-icon icon="RefreshCwIcon" class="mr-50" />
              <span class="align-middle">{{ $t('Force Telemetry') }}</span>
            </b-dropdown-item>

          </b-dropdown>
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <span class="text-muted"> {{ $t('Showing')}} {{ dataMeta.from }} {{ $t('to')}} {{ dataMeta.to }} {{ $t('of')}} {{ dataMeta.of }} {{ $t('entries')}}</span>
        </b-col>
        <!-- Pagination -->
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

          <b-pagination v-model="currentPage" :total-rows="totalIntegrations" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>

  <!-- ============================================== -->
  <!-- MODAL DE RESUMO DE ATIVOS -->
  <!-- ============================================== -->
  <b-modal
      id="modal-asset-summary"
      v-model="isAssetModalVisible"
      :title="$t('Assets Summary')"
      centered
      hide-footer
      header-bg-variant="light"
  >
    <!-- Estado de Loading -->
    <div v-if="isLoadingAssets" class="text-center py-4">
      <b-spinner variant="primary" :label="$t('Loading')" />
      <p class="mt-1 text-muted">{{ $t('Fetching data...') }}</p>
    </div>

    <!-- Dados Carregados com Sucesso -->
    <div v-else-if="assetSummaryData">
      <b-list-group class="mb-2">
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <span class="font-weight-bold">{{ $t('Total Assets')}}</span>
          <b-badge variant="primary" pill style="font-size: 0.9rem;">
            {{ assetSummaryData.totalAssets }}
          </b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <span class="text-success">{{ $t('Processed Assets')}}</span>
          <b-badge variant="light-success" pill style="font-size: 0.9rem;">
            {{ assetSummaryData.processedAssets }}
          </b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <span class="text-warning">{{ $t('Unprocessed Assets')}}</span>
          <b-badge variant="light-warning" pill style="font-size: 0.9rem;">
            {{ assetSummaryData.unprocessedAssets }}
          </b-badge>
        </b-list-group-item>
      </b-list-group>

      <div class="text-right">
        <small class="text-muted">
          {{ $t('Last sync')}}: <strong>{{ formatDate(assetSummaryData.lastSyncAtUtc) }}</strong>
        </small>
      </div>
    </div>

    <!-- Fallback caso os dados não existam e não esteja carregando -->
    <div v-else class="text-center py-3 text-muted">
      {{ $t('No data available for this integration.') }}
    </div>
  </b-modal>

  <!-- Modal: Adicionar Integração -->
  <b-modal
      id="modal-add-integration"
      v-model="isAddModalVisible"
      :title="$t('New Integration')"
      centered
      @hidden="resetModal"
  >
    <div class="mb-2">
      <label>{{ $t('Select Customer') }}</label>
      <vue-autosuggest
          v-model="modalSearchCustomer"
          :suggestions="modalFilteredOptions"
          :input-props="{ 
        id: 'modal-autosuggest__input', 
        class: 'form-control', 
        placeholder: $t('Enter customer name (min. 3 characters)') 
      }"
          @selected="onModalCustomerSelected"
          @input="onModalCustomerInputChange"
      >
        <template slot-scope="{suggestion}">
          <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
        </template>
      </vue-autosuggest>
    </div>

    <div class="mb-1">
      <label>{{ $t('Select manufacturer') }}</label>
      <v-select
          v-model="modalSelectedVendor"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="vendorOptions"
          :reduce="opt => opt.value"
          :clearable="false"
          :placeholder="$t('Select manufacturer')"
          input-id="modal-vendor-select"
      />
      <small v-if="!isPasswordVendor" class="text-muted mt-50 d-block">
        {{ $t('You will be redirected to the manufacturer to authorize access.') }}
      </small>
    </div>

    <div v-if="isPasswordVendor">
      <b-alert show variant="warning" class="mb-1">
        <div class="alert-body">
          {{ $t('Komatsu does not redirect you. Enter the account, password and fleet number. The token renews automatically.') }}
        </div>
      </b-alert>

      <b-form-group
          :label="$t('Komatsu account')"
          label-for="komatsu-account"
      >
        <b-form-input
            id="komatsu-account"
            v-model="modalAccount"
            autocomplete="username"
            spellcheck="false"
            :placeholder="$t('Komatsu account')"
        />
      </b-form-group>

      <b-form-group
          :label="$t('Password')"
          label-for="komatsu-password"
      >
        <b-input-group class="input-group-merge">
          <b-form-input
              id="komatsu-password"
              v-model="modalPassword"
              :type="passwordFieldType"
              autocomplete="new-password"
              class="form-control-merge"
          />
          <b-input-group-append is-text>
            <feather-icon
                class="cursor-pointer"
                :icon="passwordToggleIcon"
                :aria-label="passwordFieldType === 'password' ? $t('Show password') : $t('Hide password')"
                @click="togglePasswordVisibility"
            />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group
          :label="$t('Fleet number')"
          label-for="komatsu-fleet-number"
          :state="fleetNumberState"
          :invalid-feedback="fleetNumberError"
          :description="$t('Use the fleet number from the Komatsu portal. The machine serial number must be the asset chassis.')"
      >
        <b-form-input
            id="komatsu-fleet-number"
            v-model="modalFleetNumber"
            autocomplete="off"
            inputmode="text"
            spellcheck="false"
            :state="fleetNumberState"
        />
      </b-form-group>
    </div>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="isAddModalVisible = false">
        {{ $t('Cancel') }}
      </b-button>
      <b-button
          variant="primary"
          :disabled="!canSubmitIntegration"
          @click="submitIntegration"
      >
        <b-spinner v-if="isSubmitting" small class="mr-50" />
        {{ isPasswordVendor ? $t('Connect') : $t('Confirm') }}
      </b-button>
    </template>
  </b-modal>

  <!-- ============================================== -->
  <!-- MODAL DE RESULTADO DA TELEMETRIA -->
  <!-- ============================================== -->
  <b-modal
      id="modal-telemetry-result"
      v-model="isTelemetryModalVisible"
      :title="$t('Telemetry Synchronization Result')"
      size="lg"
      centered
      hide-footer
  >
    <div v-if="telemetryResultData">

      <!-- Resumo Numérico (Cards) -->
      <b-row class="text-center mb-2">
        <b-col cols="4">
          <div class="p-1 border rounded" style="background-color: #f8f8f8;">
            <h6 class="mb-0 text-muted">{{ $t('Received') }}</h6>
            <h3 class="text-primary mb-0 font-weight-bolder">{{ telemetryResultData.totalEquipmentReceived }}</h3>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="p-1 border rounded" style="background-color: rgba(40, 199, 111, 0.12);">
            <h6 class="mb-0 text-success">{{ $t('Processed') }}</h6>
            <h3 class="text-success mb-0 font-weight-bolder">{{ telemetryResultData.totalProcessed }}</h3>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="p-1 border rounded" style="background-color: rgba(234, 84, 85, 0.12);">
            <h6 class="mb-0 text-danger">{{ $t('Discarded') }}</h6>
            <h3 class="text-danger mb-0 font-weight-bolder">{{ telemetryResultData.totalDiscarded }}</h3>
          </div>
        </b-col>
      </b-row>

      <!-- Alerta com a Observação da API -->
      <b-alert v-if="telemetryResultData.observation" show variant="primary" class="mb-2">
        <div class="alert-body d-flex align-items-center">
          <feather-icon icon="InfoIcon" class="mr-50" />
          <span class="font-small-3">{{ telemetryResultData.observation }}</span>
        </div>
      </b-alert>

      <!-- Detalhamento em Abas -->
      <b-tabs pills>
        <!-- ABA: DESCARTADOS -->
        <b-tab active>
          <template #title>
            <feather-icon icon="Trash2Icon" class="mr-50" />
            <span>{{ $t('Discarded') }}</span>
            <b-badge variant="light-danger" class="ml-50 pill">{{ telemetryResultData.totalDiscarded }}</b-badge>
          </template>

          <div v-if="telemetryResultData.discarded.length > 0" class="mt-1">
            <!-- max-height com overflow para não estourar a tela se tiver 50 itens -->
            <div style="max-height: 400px; overflow-y: auto;">
              <b-table
                  :items="telemetryResultData.discarded"
                  :fields="discardedTableColumns"
                  small
                  striped
                  responsive
                  class="mb-0"
              >
                <!-- Destaque para o motivo -->
                <template #cell(reason)="data">
                  <span class="text-danger font-weight-bold font-small-3">{{ data.item.reason }}</span>
                </template>
              </b-table>
            </div>
          </div>
          <div v-else class="text-center py-3 text-muted mt-1 border rounded">
            {{ $t('No discarded items') }}
          </div>
        </b-tab>

        <!-- ABA: PROCESSADOS -->
        <b-tab>
          <template #title>
            <feather-icon icon="CheckCircleIcon" class="mr-50" />
            <span>{{ $t('Processed') }}</span>
            <b-badge variant="light-success" class="ml-50 pill">{{ telemetryResultData.totalProcessed }}</b-badge>
          </template>

          <div v-if="telemetryResultData.processed.length > 0" class="mt-1">
            <div style="max-height: 400px; overflow-y: auto;">
              <b-table
                  :items="telemetryResultData.processed"
                  :fields="processedTableColumns"
                  small
                  striped
                  responsive
                  class="mb-0"
              />
            </div>
          </div>
          <div v-else class="text-center py-3 text-muted mt-1 border rounded">
            {{ $t('No processed items') }}
          </div>
        </b-tab>
      </b-tabs>

      <div class="text-right mt-2">
        <small class="text-muted">
          {{ $t('Synced at') }}: <strong>{{ formatDate(telemetryResultData.collectedAt) }}</strong>
        </small>
      </div>

    </div>
  </b-modal>
  
</div>
</template>

<script>

import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BTable,
  BAvatar,
  BBadge,
  BPagination,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
  BTabs,
  BTab,
  BAlert,
} from 'bootstrap-vue'
import { ref, computed, onUnmounted, onMounted } from '@vue/composition-api'
import { VueAutosuggest } from 'vue-autosuggest'
import vSelect from 'vue-select'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import store from "@/store";
import inboundIntegrationStoreModule from "@/views/main/inbound-integrations/inboundIntegrationStoreModule";
import useIntegrationList from "@/views/main/inbound-integrations/useIntegrationList";
import customerStoreModule from "@/views/main/customer/customerStoreModule";
import { getInboundVendorFilterOptions, getInboundVendorLabel, getInboundVendorOptions, isPasswordInboundVendor } from "@/views/main/inbound-integrations/inboundVendors";
import { getIntlLocale } from '@/libs/i18n/dateLocale'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BAvatar,
    BBadge,
    BPagination,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BTabs,
    BTab,
    BAlert,
    vSelect,
    VueAutosuggest,
    flatPickr,
    
  },
  setup(props, { root }) {
    const INBOUND_INTEGRATION_APP_STORE_MODULE_NAME = 'app-integrations'
    const CUSTOMER_APP_STORE_MODULE_NAME = 'app-customer'

    // 1. Registro dos módulos do Vuex Store
    if (!store.hasModule(INBOUND_INTEGRATION_APP_STORE_MODULE_NAME)) {
      store.registerModule(INBOUND_INTEGRATION_APP_STORE_MODULE_NAME, inboundIntegrationStoreModule)
    }
    if (!store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) {
      store.registerModule(CUSTOMER_APP_STORE_MODULE_NAME, customerStoreModule)
    }

    // 2. Utilitários Básicos e Composables Globais no topo
    const toast = useToast()
    const user = localStorage.userData != undefined ? JSON.parse(localStorage.userData) : {}

    // Executa a listagem da tabela primeiro para disponibilizar reatividade e funções (ex: refetchData)
    const {
      tableColumns,
      perPageOptions,
      fetchIntegrations,
      refIntegrationListTable,
      searchQuery,
      currentPage,
      perPage,
      customerId, // Este ref será alterado pelo filtro de clientes abaixo
      integration,
      expiredOnly,
      refetchData,
      dataMeta,
      totalIntegrations
    } = useIntegrationList()

    // 3. Estados Reativos (Refs)

    // --> Modal de Adicionar Nova Integração
    const isAddModalVisible = ref(false)
    const isSubmitting = ref(false)
    const modalSearchCustomer = ref('')
    const modalFilteredOptions = ref([])
    const modalSelectedCustomerId = ref(null)
    const modalSelectedVendor = ref(null)
    const modalAccount = ref('')
    const modalPassword = ref('')
    const modalFleetNumber = ref('')
    const passwordFieldType = ref('password')
    const vendorOptions = getInboundVendorOptions()
    const vendorFilterOptions = getInboundVendorFilterOptions()
    const isPasswordVendor = computed(() => isPasswordInboundVendor(modalSelectedVendor.value))
    const passwordToggleIcon = computed(() => (
      passwordFieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    ))
    const fleetNumberError = computed(() => {
      const value = (modalFleetNumber.value || '').trim()
      if (!value) return ''
      return /^[a-zA-Z0-9]{1,32}$/.test(value)
        ? ''
        : root.$t('Fleet number must contain only letters and numbers.')
    })
    const fleetNumberState = computed(() => (fleetNumberError.value ? false : null))
    const canSubmitIntegration = computed(() => {
      if (!modalSelectedCustomerId.value || !modalSelectedVendor.value || isSubmitting.value) return false
      if (!isPasswordVendor.value) return true
      return Boolean(
        modalAccount.value.trim()
        && modalPassword.value
        && modalFleetNumber.value.trim()
        && !fleetNumberError.value,
      )
    })

    // --> Filtro Dinâmico de Clientes na Listagem
    const filterSearchCustomer = ref('')
    const filterFilteredOptions = ref([])

    // --> Modal de Resumo de Ativos Recebidos
    const isAssetModalVisible = ref(false)
    const isLoadingAssets = ref(false)
    const assetSummaryData = ref(null)

    // --> Modal de Resultado de Telemetria
    const isTelemetryModalVisible = ref(false)
    const telemetryResultData = ref(null)

    // Definição das colunas para as tabelas dentro do modal de telemetria
    const discardedTableColumns = [
      { key: 'equipmentId', label: root.$t('Equipment') },
      { key: 'vin', label: root.$t('VIN / Chassis') },
      { key: 'reason', label: root.$t('Reason') },
    ]

    const processedTableColumns = [
      { key: 'equipmentId', label: root.$t('Equipment') },
      { key: 'vin', label: 'VIN' },
      { key: 'hourmeter', label: root.$t('Horimeter') },
      { key: 'odometer', label: root.$t('Odometer') },
    ]

    // 4. Funções e Handlers Compartilhados (Helpers)

    const vendorLabel = (code) => getInboundVendorLabel(code)

    // Função base para buscar clientes no Vuex para evitar duplicidade de código
    const fetchCustomersHelper = async (query) => {
      try {
        const response = await store.dispatch('app-customer/fetchCustomers', {
          q: query,
          page: 1,
          perPage: 5
        })
        return response?.data?.data || []
      } catch (error) {
        return []
      }
    }

    // Conversão de ISO para string amigável no formato brasileiro (DD/MM/AAAA HH:mm)
    const formatDate = (dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString(getIntlLocale(), {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    // 5. Lógica Operacional do Filtro de Clientes (Tabela)
    const onFilterCustomerInputChange = async (text) => {
      if (!text) {
        customerId.value = ''
        filterFilteredOptions.value = []
        return
      }
      if (text.length < 3) return

      const data = await fetchCustomersHelper(text)
      filterFilteredOptions.value = data.length > 0 ? [{ data }] : []
    }

    const onFilterCustomerSelected = (option) => {
      if (option) {
        customerId.value = option.item.id // Altera a ref do useIntegrationList, disparando o watch da tabela
        filterSearchCustomer.value = option.item.name
        filterFilteredOptions.value = []
      }
    }

    const clearCustomerFilter = () => {
      filterSearchCustomer.value = ''
      customerId.value = '' // Limpa o filtro e força a tabela a trazer todos os registros
      filterFilteredOptions.value = []
    }

    // 6. Lógica Operacional do Modal de Cadastro de Integração
    const openAddIntegrationModal = () => {
      isAddModalVisible.value = true
    }

    const resetModal = () => {
      modalSearchCustomer.value = ''
      modalFilteredOptions.value = []
      modalSelectedCustomerId.value = null
      modalSelectedVendor.value = null
      modalAccount.value = ''
      modalPassword.value = ''
      modalFleetNumber.value = ''
      passwordFieldType.value = 'password'
      isSubmitting.value = false
    }

    const togglePasswordVisibility = () => {
      passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password'
    }

    const onModalCustomerInputChange = async (text) => {
      if (!text || text.length < 3) {
        modalSelectedCustomerId.value = null
        modalFilteredOptions.value = []
        return
      }
      const data = await fetchCustomersHelper(text)
      modalFilteredOptions.value = data.length > 0 ? [{ data }] : []
    }

    const onModalCustomerSelected = (option) => {
      if (option) {
        modalSelectedCustomerId.value = option.item.id
        modalSearchCustomer.value = option.item.name
        modalFilteredOptions.value = []
      }
    }

    const submitIntegration = async () => {
      if (!canSubmitIntegration.value) return
      isSubmitting.value = true
      const passwordVendor = isPasswordVendor.value

      try {
        const integrationData = {
          vendor: modalSelectedVendor.value,
          customerId: modalSelectedCustomerId.value,
        }
        if (passwordVendor) {
          integrationData.userName = modalAccount.value.trim()
          integrationData.password = modalPassword.value
          integrationData.fleetNumber = modalFleetNumber.value.trim()
        }

        const response = await store.dispatch('app-integrations/addIntegration', {
          integrationData,
        })
        const responseData = response?.data || response

        if (!passwordVendor && responseData && responseData.authorizationUrl) {
          toast({
            component: ToastificationContent,
            props: {
              title: root.$t('Success!'),
              text: root.$t('Integration registered. You will be redirected to authentication...'),
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          isAddModalVisible.value = false

          setTimeout(() => {
            const newWindow = window.open(responseData.authorizationUrl, '_blank')
            if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
              toast({
                component: ToastificationContent,
                props: {
                  title: root.$t('Pop-up Blocked'),
                  text: root.$t('Please allow pop-ups for this site or click the link sent to authenticate.'),
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
            }
          }, 1500)

          refetchData()
          return
        }

        if (passwordVendor && responseData && responseData.success !== false) {
          const pendingToken = responseData.status === 'pending_token'
          toast({
            component: ToastificationContent,
            props: {
              title: root.$t('Success!'),
              text: pendingToken
                ? root.$t('Credentials saved. Authentication will continue automatically.')
                : root.$t('Integration connected. The token renews automatically.'),
              icon: pendingToken ? 'ClockIcon' : 'CheckIcon',
              variant: pendingToken ? 'warning' : 'success',
            },
          })
          isAddModalVisible.value = false
          refetchData()
          return
        }

        throw new Error(root.$t('Authorization URL not found in API response.'))
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: root.$t('Error creating integration'),
            text: error.response?.data?.message || error.response?.data?.error || root.$t('Could not generate authentication link.'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isSubmitting.value = false
      }
    }

    // 7. Lógica Operacional do Modal de Resumo de Ativos
    const openAssetSummaryModal = async (item) => {
      isAssetModalVisible.value = true
      isLoadingAssets.value = true
      assetSummaryData.value = null
      try {
        const response = await store.dispatch('app-integrations/fetchIntegrationAssetsSummary', {
          customerId: item.customerId,
          vendor: item.integrationName,
        })
        assetSummaryData.value = response.data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: root.$t('Error loading data'),
            text: root.$t('Could not load assets summary.'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        isAssetModalVisible.value = false
      } finally {
        isLoadingAssets.value = false
      }
    }

    // 8. Lógica Operacional de Forçar Telemetria
    const forceTelemetry = async (item) => {
      toast({
        component: ToastificationContent,
        props: {
          title: root.$t('Synchronization Started'),
          text: root.$t('Telemetry is being processed...'),
          icon: 'ClockIcon',
          variant: 'info',
        },
      })

      try {
        const response = await store.dispatch('app-integrations/fetchForceIntegrationAssetsSummary', {
          customerId: item.customerId,
          vendor: item.integrationName,
        })

        telemetryResultData.value = response.data || response
        isTelemetryModalVisible.value = true

        refetchData()

      } catch (error) {
        const retryAfter = error.response?.data?.retryAfterUtc
        const rateLimited = error.response?.status === 429
        const apiMessage = error.response?.data?.message || error.response?.data?.error
        const retryText = retryAfter
          ? `${root.$t('This address can only be queried once every 15 minutes.')} ${formatDate(retryAfter)}`
          : root.$t('This address can only be queried once every 15 minutes.')

        toast({
          component: ToastificationContent,
          props: {
            title: root.$t('Synchronization Failed'),
            text: rateLimited
              ? (apiMessage || retryText)
              : (apiMessage || root.$t('Could not process telemetry.')),
            icon: 'AlertTriangleIcon',
            variant: rateLimited ? 'warning' : 'danger',
          },
        })
      }
    }

    // 9. Ouvinte da Dica de Ouro: Escuta a resposta enviada via postMessage pela janela filha
    const handleOAuthMessage = (event) => {
      if (event.data && event.data.type === 'oauth_callback_result') {
        if (event.data.status === 'success') {
          toast({
            component: ToastificationContent,
            props: {
              title: root.$t('Connection Established!'),
              text: vendorLabel(event.data.vendor)
                ? `${vendorLabel(event.data.vendor)}: ${root.$t('Integration authorized successfully.')}`
                : root.$t('Integration authorized successfully.'),
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          refetchData()
        } else if (event.data.status === 'error') {
          toast({
            component: ToastificationContent,
            props: {
              title: root.$t('Authentication Error'),
              text: event.data.message || root.$t('Could not connect to the provider.'),
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        }
      }
    }

    // 10. Hooks de Ciclo de Vida do Componente (Lifecycle)
    onMounted(() => {
      window.addEventListener('message', handleOAuthMessage)
    })

    onUnmounted(() => {
      window.removeEventListener('message', handleOAuthMessage)

      if (store.hasModule(INBOUND_INTEGRATION_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(INBOUND_INTEGRATION_APP_STORE_MODULE_NAME)
      }
      if (store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(CUSTOMER_APP_STORE_MODULE_NAME)
      }
    })

    // 11. Exposição total das propriedades para o template HTML
    return {
      tableColumns,
      perPageOptions,
      fetchIntegrations,
      refIntegrationListTable,
      searchQuery,
      currentPage,
      perPage,
      customerId,
      integration,
      expiredOnly,
      refetchData,
      user,
      dataMeta,
      totalIntegrations,
      formatDate,

      // Resumo de Ativos
      isAssetModalVisible,
      isLoadingAssets,
      assetSummaryData,
      openAssetSummaryModal,

      // Resultado Telemetria
      isTelemetryModalVisible,
      telemetryResultData,
      discardedTableColumns,
      processedTableColumns,
      forceTelemetry,

      // Nova Integração (Modal)
      isAddModalVisible,
      isSubmitting,
      modalSearchCustomer,
      modalFilteredOptions,
      modalSelectedCustomerId,
      modalSelectedVendor,
      modalAccount,
      modalPassword,
      modalFleetNumber,
      passwordFieldType,
      passwordToggleIcon,
      isPasswordVendor,
      fleetNumberState,
      fleetNumberError,
      canSubmitIntegration,
      togglePasswordVisibility,
      vendorOptions,
      vendorFilterOptions,
      vendorLabel,
      openAddIntegrationModal,
      resetModal,
      onModalCustomerInputChange,
      onModalCustomerSelected,
      submitIntegration,

      // Filtros da Tabela
      filterSearchCustomer,
      filterFilteredOptions,
      onFilterCustomerInputChange,
      onFilterCustomerSelected,
      clearCustomerFilter
    }
  }
}
</script>

<style scoped lang="scss">
.per-page-selector {
  width: 90px;
}

.badge-notification {
  top: -5px;
  right: -5px;
  font-size: 0.6rem;
  min-width: 16px;
  height: 16px;
  line-height: 14px;
}

.my-suggestion-item {
  padding: 0.5rem 0;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>